import { useJobSearchAgreement } from "@src/appV2/redesign/Placements/hooks/useJobSearchAgreement";

import { useSelectedWorkType } from "../../hooks/useSelectedWorkType";
import {
  type OnboardingStepProps,
  OnboardingStepWrapper,
  type OnboardingStepWrapperProps,
} from "../OnboardingStepWrapper";
import { useAgreementsToDisplay } from "../utils/getAgreementsToDisplay";
import { AgreementExplanationStepContent } from "./AgreementExplanationStepContent";

interface AgreementExplanationStepProps
  extends Pick<OnboardingStepWrapperProps, "worker" | "progress" | "onBack" | "onNext" | "stage"> {
  shouldAskInterestedWorkType: boolean;
  onNavigateToICAgreement: () => void;
  onNavigateToJobSearchAgreement: () => void;
}

export function AgreementExplanationStep(props: AgreementExplanationStepProps) {
  const {
    worker,
    progress,
    onBack,
    onNext,
    stage,
    shouldAskInterestedWorkType,
    onNavigateToICAgreement,
    onNavigateToJobSearchAgreement,
  } = props;

  const { selectedWorkType: interestedWorkType } = useSelectedWorkType();

  const agreementsToDisplay = useAgreementsToDisplay({
    interestedWorkType,
    shouldAskInterestedWorkType,
  });

  const isICAgreementSigned = (worker?.signedContractorAgreements.length ?? 0) > 0;
  // FIXME: Use this logic when the type is added in the worker contract
  // const isJobSearchAgreementSigned = (worker?.signedJobSearchAgreements.length ?? 0) > 0;
  const { hasSignedJobSearchAgreement } = useJobSearchAgreement({ worker });

  const stepProps = {
    worker,
    progress,
    stage,
    onNext,
    onBack,
  };

  return (
    <OnboardingStepWrapper
      {...stepProps}
      render={(renderProps: OnboardingStepProps) => (
        <AgreementExplanationStepContent
          {...renderProps}
          agreementsToDisplay={agreementsToDisplay}
          isICAgreementSigned={isICAgreementSigned}
          isJobSearchAgreementSigned={hasSignedJobSearchAgreement}
          onNavigateToICAgreement={onNavigateToICAgreement}
          onNavigateToJobSearchAgreement={onNavigateToJobSearchAgreement}
        />
      )}
    />
  );
}
